<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="16" viewBox="0 0 13 16" fill="none">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M13 7.32843V0L0 3.63403V12.366L13 16V7.32541V7.32843ZM11.7444 6.97831V1.63592L2.192 4.30711L11.7444 6.97831ZM10.808 8.00151L1.25865 5.33032V10.6697L10.811 7.99849L10.808 8.00151ZM2.192 11.6959L11.7444 14.3671V9.02169L2.192 11.6929H2.06641L2.192 11.6959Z" fill="currentColor"/>
  </svg>
</template>